import React, { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-bone/95 backdrop-blur-xl shadow-sm' : 'bg-transparent'
      }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="font-serif text-2xl tracking-tight" data-testid="logo">
            <span className={`font-semibold ${isScrolled ? 'text-emerald_deep' : 'text-bone'}`}>Fitly</span>
            <span className={`font-light ml-1 ${isScrolled ? 'text-text_muted' : 'text-bone/60'}`}>India</span>
          </a>
          <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation">
            {['Services', 'Programs', 'Team', 'Testimonials', 'Contact'].map((item) => (
              <button key={item} onClick={() => scrollToSection(item.toLowerCase())}
                className={`hover:text-accent transition-colors text-sm tracking-wide ${isScrolled ? 'text-text_muted' : 'text-bone/70'}`}
                data-testid={`nav-${item.toLowerCase()}`}>{item}</button>
            ))}
            <a href="/success-stories" className={`hover:text-accent transition-colors text-sm tracking-wide ${isScrolled ? 'text-text_muted' : 'text-bone/70'}`}
              data-testid="nav-success-stories">Success Stories</a>
            <a href="/blog" className={`hover:text-accent transition-colors text-sm tracking-wide ${isScrolled ? 'text-text_muted' : 'text-bone/70'}`}
              data-testid="nav-blog">Blog</a>
          </nav>
          <div className="hidden md:block">
            <a href="/consultation" data-testid="header-book-call-btn"
              className="bg-accent text-emerald_deep px-7 py-2.5 text-sm tracking-wide font-semibold hover:bg-accent_light transition-all inline-flex items-center gap-2 rounded-full">
              Book Consultation <ArrowRight size={14} />
            </a>
          </div>
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className={`md:hidden ${isScrolled ? 'text-emerald_deep' : 'text-bone'}`} data-testid="mobile-menu-btn">
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        {isMenuOpen && (
          <div className="md:hidden py-6 bg-surface border border-border_custom rounded-xl mt-2 mb-4 shadow-lg" data-testid="mobile-menu">
            {['Services', 'Programs', 'Team', 'Testimonials', 'Contact'].map((item) => (
              <button key={item} onClick={() => scrollToSection(item.toLowerCase())}
                className="block w-full text-left px-6 py-3 text-text_muted hover:text-emerald_deep hover:bg-bone/50 text-sm tracking-wide">{item}</button>
            ))}
            <a href="/success-stories" className="block w-full text-left px-6 py-3 text-text_muted hover:text-emerald_deep hover:bg-bone/50 text-sm tracking-wide">Success Stories</a>
            <a href="/blog" className="block w-full text-left px-6 py-3 text-text_muted hover:text-emerald_deep hover:bg-bone/50 text-sm tracking-wide">Blog</a>
            <div className="px-6 pt-3">
              <a href="/consultation" className="block w-full bg-emerald_deep text-bone py-3 text-sm tracking-wide text-center rounded-full">Book Consultation</a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
